import axiosClient from "../axiosClient";
import { MotifTicketSupport } from "../interfaces/motif-support.interface";

export const findAllMotifsSupport = async () => {
  const { data } = await axiosClient.get<MotifTicketSupport[]>(
    "/tickets-support/motifs"
  );
  return data;
};
